export const setForm = (data, model) => dispatch => {
  dispatch({
    type: 'SET_FORM',
    data,
    model,
  });
};

export const clearForm = model => dispatch => {
  dispatch({
    type: 'CLEAR_FORM',
    data: {},
    model,
  });
};

export const modelDataChanged = (data, field, model) => dispatch => {
  dispatch({
    type: 'FORM_DATA_CHANGED',
    model,
    field,
    data,
  });
};
